<header class="c-header">
    <div class="container header_container">
        <div class="row header_row">
            <div class="col-md-1 header_col u-no_gutter">
                <a class="logo" href="" title="Logo"><img src="../assets/img/logo.svg" alt="Logo BHP"></a>
            </div>
            <div class="col-md-11 header_col">
                <nav class="c-profile">
                    <ul class="c-profile__items">
                      
                        <li class="">
                            <span class="c-profile__languaje">
                                <i class="icon icon-world">&nbsp;</i>
                                <span class="js-txt_menu23" style="color:white">
                                    <select #langselect (change)="translate.use(langselect.value)" (change)="updateLang(langselect.value)" style="background: transparent;" [(ngModel)]="selectLang" >
                                        <option *ngFor="let lang of translate.getLangs()" [value]="lang" style="color:black" > {{lang | uppercase}}</option>
                                    </select>
                                </span>
                            </span>
                        </li> 
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</header>